import { CompanyService } from '@/modules/global-settings/company/services/company.service';
import Logger from '@/lib/logger';
import { SOCKET_URL } from '@/lib/constants/env';
// Creates a new instance of the company service
const companyService = new CompanyService();

// Company module state
export const state = {
  currentCompany: {}
};

// Company module mutations
export const mutations = {
  SET_CURRENT_COMPANY(state, payload) {
    state.currentCompany = payload;
    this.dispatch('companyModule/setFavicon', payload?.logo);
  },
  SET_COMPANY_LOGO(state, payload) {
    state.currentCompany.logo = payload;
    this.dispatch('companyModule/setFavicon', payload);
  },
  UPDATE_COMPANY(state, payload) {
    state.currentCompany = payload;
    this.dispatch('companyModule/setFavicon', payload?.logo);
  },
  REMOVE_COMPANY_LOGO(state) {
    state.currentCompany.logo = '';
    this.dispatch('companyModule/setFavicon', undefined);
  }
};

// Company module actions
export const actions = {
  /**
   * Fetches the current company
   * @param {*} Object - Vuex context
   * @returns Object - Company
   */
  fetchCompany: async ({ commit }) => {
    try {
      const { data } = await companyService.fetchCompany();
      commit('SET_CURRENT_COMPANY', data);
      return data;
    } catch (error) {
      Logger.error('fetching company', error);
      throw error;
    }
  },

  /**
   * Updates the current company
   * @param {object} Object - Vuex context
   * @param {object} payload - Company data
   * @returns Object - Company data
   */
  updateCompany: async ({ commit }, payload) => {
    try {
      const data = await companyService.updateCompany(payload);
      commit('SET_CURRENT_COMPANY', payload);
      return data;
    } catch (error) {
      Logger.error('updating company', error);
      throw error;
    }
  },

  /**
   * Creates a new company
   * @param {object} Object - Vuex context
   * @param {object} payload - Company data
   * @returns Object - Company data
   */
  createCompany: async (_, payload) => {
    try {
      const company = await companyService.createCompany(payload);
      return company;
    } catch (error) {
      Logger.error('updating company', error);
      throw error;
    }
  },

  /**
   * Fetches all company apps
   * @returns Array - Company apps
   *
   * @private Not used in the current version
   */
  fetchCompanyApps: async () => {
    try {
      const { data } = await companyService.fetchCompanyApps();
      return data;
    } catch (error) {
      Logger.error('updating company', error);
      throw error;
    }
  },

  /**
   * Updates the company logo
   * @param {object} Object - Vuex context
   * @param {object} file - File to upload
   * @returns Object - Company data
   */
  updateLogo: async ({ state, dispatch }, file) => {
    try {
      await companyService.updateLogo(state.currentCompany.id, file);
      dispatch('fetchCompany');
    } catch (error) {
      Logger.error('updating company logo ', error);
      throw error;
    }
  },

  /**
   * Removes the company logo
   * @param {object} Object - Vuex context
   */
  removeLogo: async ({ state, commit }) => {
    try {
      await companyService.removeLogo(
        state.currentCompany?.id
      );
      commit('REMOVE_COMPANY_LOGO');
    } catch (error) {
      Logger.error('remove company logo ', error);
      throw error;
    }
  },

  setFavicon: async (_, url) => {
    // if no url is provided, use the default favicon
    if (!url) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = '/favicon.ico';
      document.getElementsByTagName('head')[0].appendChild(link);
      return;
    }
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = `${url}`;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
};

// Company module getters
export const getters = {
  currentCompany: (state) => state.currentCompany,
  companyImage: (state) => {
    if (!state.currentCompany) return undefined;
    if (!state.currentCompany.logo) return undefined;
    return `${state.currentCompany.logo}`;
  }
};
